import React, { MouseEvent, ReactNode, FunctionComponent } from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  TDialogProps,
  TButtonProps,
} from '@rbx/ui';

import useConfirmDialogStyles from './ConfirmDialog.styles';

export interface ConfirmDialogProps extends Pick<TDialogProps, 'open' | 'title'> {
  cancelButtonText?: string;
  cancelButtonProps?: TButtonProps;
  confirmButtonText?: string;
  confirmButtonProps?: TButtonProps;
  onCancel?: (event: MouseEvent<HTMLButtonElement>) => void;
  onConfirm?: (event: MouseEvent<HTMLButtonElement>) => void;
  skippable?: boolean;
  skipLabelText?: ReactNode;
  maxWidth?: 'XSmall' | 'Small' | 'Medium';
}

const ConfirmDialog: FunctionComponent<React.PropsWithChildren<ConfirmDialogProps>> = ({
  cancelButtonText = '',
  cancelButtonProps = {},
  confirmButtonText = '',
  confirmButtonProps = {},
  children,
  onCancel,
  onConfirm,
  open,
  title = '',
  maxWidth = 'XSmall',
}) => {
  const {
    classes: { wordWrap },
  } = useConfirmDialogStyles();
  const { classes: cancelButtonClasses, ...otherCancelButtonProps } = cancelButtonProps;
  const { classes: confirmButtonClasses, ...otherConfirmButtonProps } = confirmButtonProps;

  return (
    <Dialog maxWidth={maxWidth} open={open} onClose={onCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        <DialogContentText className={wordWrap}>{children}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant='outlined'
          color='primary'
          onClick={onCancel}
          classes={cancelButtonClasses}
          {...otherCancelButtonProps}>
          {cancelButtonText}
        </Button>
        <Button
          variant='contained'
          onClick={onConfirm}
          classes={confirmButtonClasses}
          {...otherConfirmButtonProps}>
          {confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
